import React from "react";
import { CHAIN_ID, PUBLIC } from "../config";

/**
 * The tape. Ink on paper, thin, slow. First thing that feels expensive.
 * Reads from the passed `rows` so it moves with the board.
 * Halt in ink-down, After hours in muted, RTH default.
 */
export default function Tape({ rows }) {
  const nvda = rows.find((r) => r.ticker === "NVDA");
  const spy = rows.find((r) => r.ticker === "SPY");
  const coin = rows.find((r) => r.ticker === "COIN");
  const spcx = rows.find((r) => r.ticker === "SPCX");
  const tsla = rows.find((r) => r.ticker === "TSLA");
  const aapl = rows.find((r) => r.ticker === "AAPL");
  if (!nvda || !spy || !coin || !spcx || !tsla || !aapl) return <div className="tape-wrap" data-testid="tape" />;

  const fmt = (v) => (v == null ? "—" : Number(v).toFixed(2));
  const pct = (r) => {
    if (r.pool == null || r.nav == null || r.nav === 0) return null;
    return ((r.pool - r.nav) / r.nav) * 100;
  };
  const dNvda = pct(nvda);
  const dSpy  = pct(spy);
  const pctStr = (d) => d == null ? "—" : `${d >= 0 ? "+" : "−"}${Math.abs(d).toFixed(2)}%`;
  const pctCls = (d) => d == null ? "muted" : d === 0 ? "" : d > 0 ? "up" : "down";

  const status = PUBLIC ? "READ FROM ROBINHOOD CHAIN 4663" : "PREVIEW · READ FROM ROBINHOOD CHAIN 4663";

  const items = [
    { k: "NVDA POOL", v: fmt(nvda.pool) },
    { k: "NVDA NAV",  v: fmt(nvda.nav)  },
    { k: "Δ", v: pctStr(dNvda), cls: pctCls(dNvda) },
    { k: "SPY",  v: `${fmt(spy.pool)} · ${spy.session}` },
    { k: "COIN", v: coin.session, cls: coin.session === "HALT" ? "down" : coin.session === "AH" ? "muted" : "" },
    { k: "SPCX", v: spcx.session === "AH" ? "AFTER HOURS" : spcx.session, cls: spcx.session === "HALT" ? "down" : "muted" },
    { k: "TSLA", v: fmt(tsla.pool) },
    { k: "AAPL", v: fmt(aapl.pool) },
    { k: "PONS CURVE", v: "62%" },
    { k: "PAIR", v: "NVDA/USDG" },
    { k: "PAIR", v: "GOLDLEAF/NVDA" },
    { k: "SPY POOL Δ", v: pctStr(dSpy), cls: pctCls(dSpy) },
    { k: null, v: status, cls: "muted" },
    { k: `CHAIN ${CHAIN_ID}`, v: "ETH GAS · USDG QUOTE" },
  ];

  const renderLine = (keyPrefix) => items.map((it, i) => (
    <React.Fragment key={`${keyPrefix}-${i}`}>
      {it.k && <span className="lbl">{it.k}</span>}
      <span className={it.cls === "muted" ? "lbl" : it.cls}>{it.v}</span>
      <span className="sep">···</span>
    </React.Fragment>
  ));

  return (
    <div className="tape-wrap" data-testid="tape">
      <div className="tape-track">
        <span style={{ display: "inline-flex", alignItems: "center", gap: 12 }}>{renderLine("a")}</span>
        <span style={{ display: "inline-flex", alignItems: "center", gap: 12 }}>{renderLine("b")}</span>
      </div>
    </div>
  );
}
